import React from 'react'

const Mute = () => (
  <svg viewBox='0 0 24 24' aria-hidden='true'>
    <path d='M7 9v6h4l5 5V4l-5 5H7z'></path>
  </svg>
)

export default Mute
